<template>
	<div v-if="loaded">
		<div class="md-layout">
			<div class="md-layout-item md-small-size-100 md-size-50">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<h3>Investor Information</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100 text-right">
					<span class="late">* required</span>
				</div>
				<div class="md-layout">
					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>Investor Name *</label>
							<md-input type="text" v-model="investor.name"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>Investor Khmer Name *</label>
							<md-input type="text" v-model="investor.name_khmer"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-33">
						<md-field>
							<label>Gender *</label>
							<md-select placeholder="Gender *" v-model="investor.gender">
								<md-option value="f">Female</md-option>
								<md-option value="m">Male</md-option>
								<md-option value="o">Other</md-option>
							</md-select>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-33">
						<md-field>
							<label>Date of Birth *</label>
							<md-input type="text" v-model="investor.dob"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-33">
						<md-field>
							<label>Client Phone *</label>
							<md-input type="text" v-model="investor.phone"></md-input>
						</md-field>
					</div>

					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>ID Card Number *</label>
							<md-input type="text" v-model="investor.id_card"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>Occupation *</label>
							<md-input type="text" v-model="investor.occupation"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-field>
							<label>Address</label>
							<md-input type="text" v-model="investor.address">
							</md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-field>
							<label>Document Link</label>
							<md-input type="text" v-model="investor.doc_url">
							</md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-field>
							<label>Bank Account</label>
							<md-input type="text" v-model="investor.bank">
							</md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-field>
							<label>Client Note</label>
							<md-input type="text" v-model="investor.note">
							</md-input>
						</md-field>
					</div>
					<!-- <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-size-100 file-image"
						style="text-align: center;">
						<div class="file-image-wrapper">
							<h6>ID Card Photo</h6>
							<div class="md-layout-item md-small-size-100 md-size-100" style="min-height: 150px;">
								<input type="file" ref="id_card" accept="image/*" style="display: none;"
									@change="processFile($event, 'id_card')">
								<img class="thumb-product" src="/id-card.png" v-if="String(client.image_url).length == 0">
								<img class="thumb-product" :src="client.image_url" v-if="String(client.image_url).length > 12">
								<img class="thumb-product" :src="config.getImageUrl(client.image_url)"
									v-if="String(client.image_url).length == 12">
							</div>

							<md-button class="md-primary" @click="openImage('id_card')"
								v-if="String(client.image_url).length == 0">Upload</md-button>
							<md-button class="md-primary" @click="removeImage()" v-else>Remove</md-button>
						</div>
					</div> -->
				</div>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<h3>Summary</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100">
					<md-table>
						<md-table-row>
							<md-table-cell style="width: 50%;">Client Name</md-table-cell>
							<md-table-cell style="width: 5px">:</md-table-cell>
							<md-table-cell>
								<span v-if="String(investor.name).length > 0">{{investor.name}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>Client Khmer Name</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(investor.name_khmer).length > 0">{{investor.name_khmer}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>Gender</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(investor.gender).length > 0 && investor.gender == 'm'">Male</span>
								<span v-else-if="String(investor.gender).length > 0 && investor.gender == 'f'">Female</span>
								<span v-else-if="String(investor.gender).length > 0 && investor.gender == 'o'">Other</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>Date of Birth</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(investor.dob).length > 0">{{investor.dob}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>Occupation</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(investor.occupation).length > 0">{{investor.occupation}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>Client Phone</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(investor.phone).length > 0">{{investor.phone}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>ID Card</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(investor.id_card).length > 0">{{investor.id_card}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>Address</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(investor.address).length > 0">{{investor.address}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>Bank Account</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(investor.bank).length > 0">{{investor.bank}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>Client Note</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(investor.note).length > 0">{{investor.note}}</span>
								<span v-else>N/A</span>
							</md-table-cell>
						</md-table-row>
					</md-table>
				</div>
			</div>
			<div class="md-layout-item md-size-100 text-right">
				<md-button class="md-raised md-primary" @click="updateInvestor()">Update</md-button>
			</div>
		</div>
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	import { Settings } from 'luxon'
	Settings.defaultLocale = 'km'
	export default {
		components: {
			datetime: Datetime
		},
		created() {
			this.getInvestor();

		},
		data() {
			return {
				loaded: false,
				investor: {
					valid: false,
					id: "",
					name: "",
					name_khmer: "",
					phone: "",
					gender: "",
					note: "",
					bank: "",
					dob: "",
					doc_url: "",
					occupation: "",
					address: "",
					id_card: ""
				}
			}
		},
		methods: {
			updateInvestor() {
				if (!this.checkValidation()) return false;
				this.$http.post(this.config.api + "/admin/investor/update", {
					investor: this.investor
				}).then(data => {
					if (data.body.status == 'success') {
						this.tabName = 'first'
						this.$notification.notify({
							message: "Investor was update successfully.",
							icon: 'done',
							type: 'success'
						});
						this.$router.push("/investors");
					}
				})
			},
			checkValidation() {
				if (String(this.investor.name).length > 0 && String(this.investor.name_khmer).length > 0
					&& String(this.investor.phone).length > 0 && String(this.investor.gender).length > 0
					&& String(this.investor.dob) && String(this.investor.id_card) && String(this.investor.occupation)
					&& String(this.investor.image_url).length > 0) {
					return true;
				} else {
					this.$notification.notify({
						message: "Please fill in information.",
						icon: 'info',
						type: 'warning'
					});
					return false;
				}
			},

			getInvestor() {
				this.$http.get(this.config.api + "/admin/investor/get/" + this.$route.params.hash_id).then(data => {
					this.investor = data.body.data
					this.loaded = true;
				})
			}
		}
	}
</script>
<style>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50% !important;
	}

	.file-image-wrapper {
		/* margin: 10px; */
		width: calc(100%);
		padding-top: 8px;
		padding-bottom: 5px;
		border: 1px solid #ccc;
		border-radius: 5px;
	}

	.file-image {
		margin-top: 21px;
		text-align: center;
		/* margin-left: 10px;
		margin-right: 10px; */
		/* min-width: calc(33.3333% - 20px) !important;
		max-width: calc(33.3333% - 20px) !important;
		flex: 0 1 calc(33.3333% - 20px) !important; */
		/* padding: 0; */
	}

	.vdatetime-input {
		border: 0;
		width: 100%;
		height: 32px;
	}

	.vdatetime {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Investors/Edit.vue